
import { Vue } from "vue-property-decorator";
import Component from "vue-class-component";
import { useConsultorioStore } from '../../store/consultorioStore';
import { globalStore } from '../../store/globalStore';
import { consultorioService } from '../../services/ConsultorioService';
import { DateTime } from "luxon";
import { Reporte } from "@/addons/Reporte";

@Component({
	name: "ReporteIngresos",
	components: { HeadReport: () => import('@/components/HeadReport.vue') }
})
export default class ReporteIngresos extends Vue {

	private globalStore = globalStore();
	private consultorioStore = useConsultorioStore();
	private consultorioService = consultorioService.getInstance();
	public dialog = false;
	public fechaInicial = DateTime.now().minus({days: 30}).toFormat("yyyy-MM-dd");
	public fechaFinal = DateTime.now().toFormat("yyyy-MM-dd");
	public txtSearch = '';
	mounted() {
		this.getReporteIngresos();
	}
	getReporteIngresos() {
		let data = {
			fecha_inicial: this.fechaInicial,
			fecha_final: this.fechaFinal,
			txtSearch: this.txtSearch
		}
		this.consultorioService.getPagos(data)
	}

	get ingresos(): any {
		return this.consultorioStore.pagos;
	}
	get loading(): boolean {
		return this.consultorioStore.loading;
	}
	get totalIngresos(): number {
		return this.ingresos.reduce((total: number, ingreso: any) => total + ingreso.monto, 0);
	}
	imprimir() {
    const css = ".print table {border-collapse: collapse} .print td {padding:0.5 !important; font-size: xx-small !important;}"
    const p = new Reporte('area_impresion');
    p.orientacion ='vertical';
    p.otroCss = css;
    p.imprimir();
  }

}
